<app-header></app-header>
<div class="page-content">

  <!-- Ad Card -->
  <app-smart-card cardType="promo"
    title="Contratar seguro médico para estudiantes en España."
    description="Con todas las coberturas que exige casa amarilla"
    imageUrl="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public"
    badgeText="SEGURO MÉDICO"
    ctaText="Quiero saber más"
    linkUrl="/sub-app/health-helper"
    section="solicitarInfoSeguro"
    (ctaClicked)="handleCta($event)">
  </app-smart-card>

  <div class="spacer-section"></div>
  <span class="medium-gray-title">Es momento de comenzar con tus planes</span>

  <app-slider-horizontal [items]="arrayResult" [itemTemplate]="introArticles"></app-slider-horizontal>

  <ng-template #introArticles let-item>
    <app-card-with-footer id="articleSlider" [cardInfo]="item"></app-card-with-footer>
  </ng-template>

  <div class="spacer-section"></div>

  <h1 class="webapp-title">{{ 'WEBAPP.SERVICES.SERVICES' | translate }}</h1>
  <h2 class="webapp-title-secondary">{{ 'WEBAPP.SERVICES.SERVICE_LABEL_1' | translate }}</h2>
  
  <h5 class="webapp-pre-title">Resolvemos tus dudas y te guiamos!</h5>
  <p>Te acompañaremos durante todo el proceso, brindamos asistencia personalizada, documentación etc.</p>
  <h5 class="webapp-pre-title">Soluciones</h5>
  <p>Te explicamos por dónde comenzar según el plan que tengas en mente. </p>

  <div class="spacer-section"></div>
  <!-- No olvides tu seguro médico -->
  <app-banner-card></app-banner-card>

  <!-- SLIDES MEJORES MOMENTOS -->
  <h2 class="webapp-title-secondary">Algunos momentos en mi camino...</h2>
  <app-slider-horizontal [items]="algunosMomentos" [itemTemplate]="artistCardTemplate"></app-slider-horizontal>

  <ng-template #artistCardTemplate let-map>
    <app-image-portrait [city]="map.city" [image]="map.imageUrl" [link]="'map.link'" [id]="map.id" [date]="map.date"></app-image-portrait>
  </ng-template>

  <div class="spacer-section"></div>
  <span class="medium-gray-title">Quiero comenzar!</span>
  <div class="spacer-md"></div>

  <app-card-image-simple [cardInfo]="quieroComenzar"></app-card-image-simple>

  <!-- Existing content -->
  <!-- <div class="latest-news">
    <div class="section-title">
      Últimas noticias
    </div>
    <div class="news-card">
      <mat-icon>info</mat-icon>
      <h4>ETIAS - Sistema Europeo de Información y Autorización de Viajes</h4>
      <p>Conozca más sobre los nuevos requisitos de viaje a Europa a partir de 2025.</p>
    </div>
  </div> -->
  
  <div class="spacer-section"></div>
  <!-- ULTIMOS ARTICULOS DEL BLOG -->
  <!-- <app-section-post-list-img [sectionInfo]="blogArticles"></app-section-post-list-img> -->

  <!-- <div class="blog-articles">
    <h3>Últimos Artículos del Blog</h3>
    <div class="article-card" *ngFor="let article of blogArticles" (click)="openArticle(article)">
      <mat-icon>article</mat-icon>
      <h4>{{ article.title }}</h4>
      <p>{{ article.snippet }}</p>
    </div>
  </div> -->
  
  <!-- <app-card-with-content [cardInfo]="legalService"></app-card-with-content> -->

  <h2 *ngIf="false" class="webapp-title-secondary">Servicios Adicionales</h2>
  <div  *ngIf="false" class="horizontal-scroll">
    <div *ngFor="let service of additionalServicesOld">
      <div class="artist-card">
        <!-- <img [src]="artist.imageUrl" alt="{{ artist.title }}"> -->
        <mat-icon class="icon-lg">{{ service.icon }}</mat-icon>
        <div class="artist-title">{{ service.title }}</div>
        <div class="artist-description">{{ service.description }}</div>
        <button class="cta-button" (click)="hireService(service)">Me interesa</button>
      </div>
    </div>
  </div>

  <div class="spacer-section"></div>

  <!-- Promo Card -->
  <app-smart-card cardType="promo-banner"
    title="¿Listo para viajar a Europa?"
    description="Te ayudamos a empezar tu nueva aventura."
    imageUrl="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public"
    badgeText="SEGURO MÉDICO"
    ctaText="Reservar videollamada"
    linkUrl="faqs"
    (ctaClicked)="buyProductSimple('videocall60')">
  </app-smart-card>

  <!-- VIDEOLLAMADA 60mins -->
  <div class="card" *ngIf="debug">
    <h1 class="webapp-title">Reservar videollamada</h1>
    <h5 class="webapp-pre-title">60 minutos</h5>
    <!-- Offer Description -->
    <p>Imagina tener a <strong>alguien en España que ya pasó</strong> por lo mismo que tú… y ahora puede guiarte paso a paso.
    <p class="price">
      Precio: <strong>35 EUR</strong>
    </p>
    <p>En esta llamada resolveremos todas tus dudas en directo: desde trámites, visado, estudios, hasta la vida cotidiana.
Yo ya recorrí ese camino y sé lo que se siente estar con mil preguntas y sin saber por dónde empezar.</p>
    <!-- Checklist of Requirements -->
    <!-- <h2 class="webapp-title-secondary">Información requerida:</h2> -->
    <ul class="requirements">
      <li>✅ Respuestas claras y sin rodeos</li>
      <li>✅ Consejos prácticos que no salen en Google</li>
      <li>✅ Trucos de alguien que ya lo vivió en España</li>
    </ul>

    <p>Reserva tu hora y quédate con la tranquilidad de tener un plan claro para dar el siguiente paso en tu proyecto de venir a España.</p>

    <!-- CONTRATAR -->
    <button mat-button *ngIf="!isStatus('paid')" (click)="buyProduct('videocall60')" class="button btn-premium color-action button-round">
      <mat-spinner [diameter]="30" class="dark-button-spinner center" *ngIf="isStatus('processing')"></mat-spinner>
      <span *ngIf="!isStatus('processing')">{{'VIDEOCALL.HIRE_BUTTON' | translate}}</span>
    </button>

    <!-- RESERVAR -->
    <button mat-button *ngIf="isStatus('paid')" (click)="bookVideocall('videocall60')" class="button btn-premium color-action button-round">
      <span>{{'VIDEOCALL.BOOK_BUTTON' | translate}}</span>
    </button>

    <div *ngIf="isStatus('processing')" class="loading-overlay center">
      <div class="spinner"></div>
      <p>Procesando orden...</p>
    </div>
  </div>
  <div #videocall60></div>

  <!-- <div class="section-title">
    Explorando...
  </div>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/Una5pHNy_kQ?controls=0"
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen>
    </iframe> -->
  
  <!-- 
  <h2 class="webapp-title-secondary">Servicios Adicionales</h2>
  <div class="additional-services">
    <div class="card service-card" *ngFor="let service of additionalServicesOld">
      <div>
        <mat-icon class="icon-lg">{{ service.icon }}</mat-icon>
        <h2 class="webapp-title-secondary">{{ service.title }}</h2>
        <p>{{ service.description }}</p>
        <button class="button button-fill color-dark" (click)="hireService(service)">Me interesa</button>
      </div>
    </div>
  </div> -->
</div>
<div class="spacer-section"></div>
<app-footer></app-footer>



<!-- Premium Card (Pending Payment) -->
 <!--  <app-mega-card
  cardType="premium"
  title="Premium Access"
  description="Exclusive premium content."
  imageUrl="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public"
  badgeText="PREMIUM"
  status="pending"
  ctaText="Pay Now"
  (ctaClicked)="handleCta('premium')">
  </app-mega-card> -->

  <!-- Locked Content -->
<!--   <app-mega-card
  cardType="locked"
  title="Locked Feature"
  description="Unlock this feature by upgrading."
  imageUrl="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public"
  badgeText="LOCKED"
  ctaText="Upgrade"
  (ctaClicked)="handleCta('locked')">
  </app-mega-card> -->

  <!-- Promo Card -->
 <!--  <app-mega-card
  cardType="promo"
  title="Special Offer!"
  description="Get 50% off premium access."
  imageUrl="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public"
  badgeText="PROMO"
  ctaText="Claim Now"
  (ctaClicked)="handleCta('promo')">
  </app-mega-card> -->

  <!-- Premium Card (Pending Payment) -->
<!--   <app-smart-card
  cardType="premium"
  title="Premium Access"
  description="Exclusive premium content."
  imageUrl="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public"
  badgeText="PREMIUM"
  status="pending"
  ctaText="Pay Now"
  (ctaClicked)="handleCta('premium')">
  </app-smart-card> -->

    <!-- Free Card -->
  <!-- <app-mega-card cardType="free" title="Free Content" description="Access to free features."
    imageUrl="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public"
    badgeText="FREE"
    ctaText="View Now"
    (ctaClicked)="handleCta('free')">
  </app-mega-card> -->